/**
 * Motion Preferences Utility
 * 
 * Manages reduced motion CSS custom properties for accessibility.
 * Respects system preferences and user overrides.
 */

/**
 * Apply reduced motion CSS custom properties
 * Called on mount and when user toggles preference
 */
export function applyReducedMotion(enabled: boolean): void {
  const root = document.documentElement;
  
  // Update CSS variables used throughout the app
  root.style.setProperty('--motion-fast', enabled ? '0ms' : '120ms');
  root.style.setProperty('--motion-normal', enabled ? '0ms' : '160ms');
  root.style.setProperty('--motion-slow', enabled ? '0ms' : '260ms');
  
  // Store preference in localStorage for persistence
  try {
    localStorage.setItem('oro-reduced-motion', JSON.stringify(enabled));
  } catch (e) {
    console.warn('Failed to save motion preference:', e);
  }
}

/**
 * Get initial reduced motion preference
 * Checks system preference first, then user override
 */
export function getInitialReducedMotion(): boolean {
  // Check if user has explicitly set a preference
  try {
    const stored = localStorage.getItem('oro-reduced-motion');
    if (stored !== null) {
      return JSON.parse(stored);
    }
  } catch (e) {
    console.warn('Failed to read motion preference:', e);
  }
  
  // Fallback to system preference
  if (window.matchMedia) {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  
  // Default to false if no preference available
  return false;
}
